import { Action } from "@ngrx/store";
import { IServerResponse } from "app/interface";
import {
    LOCATION_LIST, GET_LOCATION_LIST, SAVE_LOCATION, SAVE_LOCATION_RESPONSE,
    DELETE_LOCATION, DELETE_LOCATION_RESPONSE
} from "./actionTypes";

export class GetLocationList implements Action {
    readonly type = GET_LOCATION_LIST;
}

export class LocationList implements Action {
    readonly type = LOCATION_LIST;
    readonly payload = []
    constructor(userToBillList: Array<any>) {
        this.payload = userToBillList;
    }
}

export class SaveLocation implements Action {
    readonly type = SAVE_LOCATION;
    readonly payload: any;
    constructor(data) {
        this.payload = data;
    }
}

export class SaveLocationResponse implements Action {
    readonly type = SAVE_LOCATION_RESPONSE;
    readonly payload: IServerResponse;
    constructor(data) {
        this.payload = data;
    }
}

export class DeleteLocation implements Action {
    readonly type = DELETE_LOCATION;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class DeleteLocationResponse implements Action {
    readonly type = DELETE_LOCATION_RESPONSE;
    readonly payload: IServerResponse;
    constructor(data) {
        this.payload = data;
    }
}

export type Actions = GetLocationList | LocationList | SaveLocation | SaveLocationResponse |
    DeleteLocation | DeleteLocationResponse;
